import React from 'react';
import ReactDOM from 'react-dom';
import bridge from '@vkontakte/vk-bridge';
import App from './App';

import OKSDK from './ok/oksdk';
import launchState from './ok/launchState';

// Init VK  Mini App
bridge.send('VKWebAppInit');

ReactDOM.render(<App />, document.querySelector('#root'));
if (process.env.NODE_ENV === 'development') {
  import('./eruda.js').then(({default: _eruda}) => {}); // Runtime download
}

if (launchState.getHasToken()) {
  OKSDK.init({
    app_id: launchState.appId,
    app_key: launchState.appKey,
    location_hash: `#access_token=${launchState.getAccessToken()}`,
  });
}
